import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import loding from './loading'
import toasted from './toasted'
import gFunction from './globalFunction'
import VueSocketIO from 'vue-socket.io'
import i18n from './i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './assets/scss/main.scss'

Vue.use(gFunction);

Vue.config.productionTip = false;
Vue.use(new VueSocketIO({
  debug: false,
  //connection: 'http://192.168.1.174:3000',
  //connection: 'https://socketiouat.surreal.com.tw',
  connection: 'https://socketioedu.surreal.com.tw',

  options: {
    path: "",
    autoConnect: false,
  }
}))

new Vue({
  router,
  store,
  loding,
  toasted,
  i18n,
  gFunction,
  render: h => h(App)
}).$mount('#app')

